import { listify, makeClassName, pluralize } from '@siteless/util';
import { CurrentUserMustResource } from '../resources/Auth/CurrentUserMust';
import optionTypes from '../resources/Ballot/constants/optionTypes';
import { toggleUserFavoriteMutation } from '../resources/UserFavorites/mutations';
import { OneUserFavoritesResource } from '../resources/UserFavorites/One';
import useCopy from '../util/useCopy';
import Action from './Action';
import { HeartIcon } from './HeartIcon';
import { HeartOutlineIcon } from './HeartOutlineIcon';
import { IconAlertTriangle } from './IconAlertTriangle';

export let ComposeBallotFocusCategoryItem = ({
  posterImageUrl,
  supportImageUrl,
  title,
  type,
  favoriteConfig,
  supportFavoriteConfig,
  strictModeUserLeagueNames,
  isSelected,
}: {
  type: (typeof optionTypes)[keyof typeof optionTypes];
  title: string;
  posterImageUrl?: string;
  supportImageUrl?: string;
  favoriteConfig?: {
    type: 'film' | 'person';
    key: string;
  };
  supportFavoriteConfig?: {
    type: 'film' | 'person';
    key: string;
  };
  strictModeUserLeagueNames: string[];
  isSelected: boolean;
}) => {
  let copy = useCopy();
  let currentUser = CurrentUserMustResource.use();
  let favorites = OneUserFavoritesResource.useLoadable(currentUser.id)[0] || [];
  let isFavorite = Boolean(
    favorites.find(({ key }) => key === favoriteConfig?.key),
  );
  let isSupportFavorite = Boolean(
    favorites.find(({ key }) => key === supportFavoriteConfig?.key),
  );

  return (
    <>
      {Boolean(
        strictModeUserLeagueNames.length && type.key !== 'winner' && isSelected,
      ) && (
        <div className={makeClassName('absolute top-1 right-1 h-6 w-6')}>
          <Action
            disablePadding
            Icon={IconAlertTriangle}
            onClick={(event) => {
              event.stopPropagation();
              window.alert(
                `
${copy.strictScoringCategoryItemExplanation}

${pluralize({
  count: strictModeUserLeagueNames.length,
  singular: copy.League,
  hideCount: true,
})}: ${listify(strictModeUserLeagueNames, copy.and)}
              `.trim(),
              );
            }}
          />
        </div>
      )}
      {favoriteConfig && (
        <div
          className={makeClassName('absolute top-1 right-1 h-6 w-6')}
          onClick={(event) => {
            event.stopPropagation();
            toggleUserFavoriteMutation({
              userId: currentUser.id,
              favorites,
              favorite: favoriteConfig,
            });
          }}
        >
          {isFavorite ? (
            <div className="relative h-full w-full">
              <HeartIcon className="text-rose-bright absolute h-full w-full" />
              <HeartOutlineIcon className="text-rose-bright absolute h-full w-full" />
            </div>
          ) : (
            <div className="relative h-full w-full">
              <HeartIcon className="text-neutral-0/50 absolute h-full w-full" />
              <HeartOutlineIcon className="absolute h-full w-full text-neutral-200" />
            </div>
          )}
        </div>
      )}
      {posterImageUrl ? (
        <img
          src={posterImageUrl}
          alt={title}
          style={{
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            borderRadius: 4,
          }}
        />
      ) : (
        <div className="flex h-full flex-col justify-between p-2 text-sm">
          <type.Icon />
          <div>{title}</div>
        </div>
      )}
      {supportFavoriteConfig && (
        <div
          className={makeClassName(
            'absolute bottom-[40px] right-[2px] z-20 h-5 w-5',
          )}
          onClick={(event) => {
            event.stopPropagation();
            toggleUserFavoriteMutation({
              userId: currentUser.id,
              favorites,
              favorite: supportFavoriteConfig,
            });
          }}
        >
          {isSupportFavorite ? (
            <div className="relative h-full w-full">
              <HeartIcon className="text-rose-bright absolute h-full w-full" />
              <HeartOutlineIcon className="text-rose-bright absolute h-full w-full" />
            </div>
          ) : (
            <div className="relative h-full w-full">
              <HeartIcon className="text-neutral-0/50 absolute h-full w-full" />
              <HeartOutlineIcon className="absolute h-full w-full text-neutral-200" />
            </div>
          )}
        </div>
      )}
      {supportImageUrl && (
        <img
          alt={title}
          src={supportImageUrl}
          style={{
            right: 4,
            bottom: 4,
            border: '3px solid white',
            position: 'absolute',
            height: 60,
            width: 60,
            objectFit: 'cover',
            borderRadius: '50%',
            zIndex: 1,
          }}
        />
      )}
    </>
  );
};
